import { CarAnimation } from "./components/CarAnimation";
import { FormValidator } from "./components/FormValidator";
import { arrowUpBtn, donationFormSubmitHandler, donationTextSlider, initPhoneMask, primaryMenu } from "./utils/helpers";
import { initFaqAccordion } from "./utils/faq-accordion";
import { initAboutTextToggle } from "./utils/about-text-toggle";
import Popup from "./utils/popup-window";
import 'swiper/css';

// Styles entry
export { }

// Minimal boilerplate JS
const onLoad = () => {
	const popup = new Popup();

	new FormValidator('.wpcf7-form');
	new FormValidator('#popup-form-shorcode .wpcf7-form');

	popup.init();

	primaryMenu();
	donationTextSlider();
	initPhoneMask();

	const paymentWidget = new TipTopPaymentWidget();

	let sfAgents = [];
	let sfVenues = [];

	fetch(php_vars.ajax_url + '?action=sf_get_active_data')
		.then(r => r.json())
		.then(data => {
			if (!data.success) return;
			sfAgents = data.agents || [];
			sfVenues = data.venues || [];

			const agentSelect = document.querySelector('.js-sf-agent-select');
			if (agentSelect && sfAgents.length) {
				agentSelect.innerHTML = '<option value="">' + (agentSelect.options[0]?.text || 'Select agent') + '</option>';
				sfAgents.forEach(a => {
					const opt = document.createElement('option');
					opt.value = a.id;
					opt.textContent = `${a.name} ID: ${a.id}`;
					agentSelect.appendChild(opt);
				});
			}

			const venueSelect = document.querySelector('.js-sf-venue-select');
			if (venueSelect && sfVenues.length) {
				venueSelect.innerHTML = '<option value="">' + (venueSelect.options[0]?.text || 'Select venue') + '</option>';
				sfVenues.forEach(v => {
					const opt = document.createElement('option');
					opt.value = v.id;
					opt.textContent = v.name;
					venueSelect.appendChild(opt);
				});
			}
		})
		.catch(e => console.error('SF fetch error:', e));

	const urlParams = new URLSearchParams(window.location.search);
	const metadata = {
		campaign_id: tiptopSettings.campaignId || 'donation.redcrescent.kz'
	};

	if (urlParams.get('source_code_id')) {
		metadata.source_code_id = urlParams.get('source_code_id');
	}

	// Must be created before the submit handlers below — they receive them as a guard
	const donationValidator = new FormValidator('.js-donation-form');
	const subscriptionValidator = new FormValidator('.js-donation-subscription-form');

	donationFormSubmitHandler('.js-donation-form', {
		widget: paymentWidget,
		metadata: metadata,
		validator: donationValidator,
		onSuccess: (res) => {
			popup.openOnePopup('#popup-donation-success-modal');
		},
	});

	donationFormSubmitHandler('.js-donation-subscription-form', {
		widget: paymentWidget,
		isSubscription: true,
		metadata: metadata,
		validator: subscriptionValidator,
		onSuccess: () => {
			popup.openOnePopup('#popup-donation-success-modal');
		},
	});

	// document.addEventListener('wpcf7mailsent', function (event) {
	// 	setTimeout(() => {
	// 		window.location.href = php_vars.site_url + '/thank-you';
	// 	}, 2000)
	// }, false);


	const birthDateInput = document.getElementById('id-birth-date');
	const birthDatePlaceholder = document.querySelector('.js-date-placeholder');

	function togglePlaceholder() {
		if (!birthDateInput || !birthDatePlaceholder) return;

		birthDatePlaceholder.style.display = birthDateInput.value ? 'none' : 'block';
	}

	if (birthDateInput) {
		birthDateInput.addEventListener('input', togglePlaceholder);
		birthDateInput.addEventListener('change', togglePlaceholder);
	}

	togglePlaceholder();

	arrowUpBtn();

	new CarAnimation();

	initFaqAccordion();
	initAboutTextToggle();

	const customInput = document.querySelector('input[name="custom-pay-sum"]');
	const radioInputs = document.querySelectorAll('input[name="pay-sum"]');

	if (!customInput || !radioInputs.length) return;

	customInput.addEventListener('focus', () => {
		radioInputs.forEach(radio => {
			if (radio.checked) {
				radio.checked = false;
			}
		});
	});

};

window.document.addEventListener('DOMContentLoaded', onLoad);
